<template>
  <nav class="navbar navbar-dark ms-top-bar-color ms-top-bar fixed-top">
    <div></div>
    <div
      class="d-flex align-items-center username"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasNavbar"
      aria-controls="offcanvasNavbar"
      aria-label="Toggle navigation"
    >
      <img :src="user" class="icon" />
      <span class="NKT-P3 username-text">{{ userName }}{{ appendRole() }}</span>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import user from '@/assets/svg/user.svg'
import { requiredInject } from '@/utilities/requiredInject'
import { MSAL } from '@/plugins/msal/msal'
import { useUserStore } from '@/stores/UserStore'
import { UserClient } from '@/server/MakeSenseApp-backend'

const userName = ref<string>()
const userStore = useUserStore()

const msal = requiredInject<MSAL>('MSAL')
const userClient = requiredInject<UserClient>('UserClient')

function appendRole() {
  if (userStore.isMasterAdmin) {
    return ', Master Admin'
  } else if (userStore.isAdmin) {
    return ', Admin'
  } else if (userStore.isOwnerOrHigher) {
    return ', Owner'
  } else {
    return ''
  }
}

onMounted(() => {
  watch(
    () => userStore.refreshDataCounter,
    () => {
      if (msal.isAuthenticated()) {
        userClient.currentUser().then((user) => {
          userStore.setCurrentUser(user)
          userName.value = user.name
        })
      }
    },
    { immediate: true }
  )
})
</script>

<style scoped>
.ms-top-bar {
  padding: 0.5rem 1rem;
  z-index: 1040;
}

.username-text {
  color: white;
  margin-left: 12px;
}

.username {
  cursor: pointer;
}
</style>
